import React from 'react'
import PropTypes from 'prop-types'
import CommissionedIndexPagePhoto from "../components/CommissionedIndexPagePhoto";


class ListOfCommissionedJobs extends React.Component {

    constructor(props) {
        super(props);

        const jobs = this.props.jobs;
        const pairedJobs = [];

        for (let i = 0; i < jobs.length; i += 3) {
            let pair = [];
            if (jobs[i])
                pair.push(jobs[i]);
            if (jobs[i + 1])
                pair.push(jobs[i + 1]);
            if (jobs[i + 2])
                pair.push(jobs[i + 2]);
            pairedJobs.push(pair);
        }

        this.state = {
            jobs: pairedJobs
        };

    }

    render() {
        return (
                <div className="jobs">
                    {
                        this.state.jobs.map((job, index) => {
                            return (
                                <div key={index} className="job columns">
                                    <CommissionedIndexPagePhoto
                                        link = {job[0].path}
                                        mainImageUrl={job[0].mainImageUrl}
                                        hoverImageUrl={job[0].hoverImageUrl}
                                        caption={job[0].title}
                                        color="pink"
                                        isNarrow={false}/>
                                    {
                                        job[1] ?
                                            <CommissionedIndexPagePhoto
                                                link = {job[1].path}
                                                mainImageUrl={job[1].mainImageUrl}
                                                hoverImageUrl={job[1].hoverImageUrl}
                                                caption={job[1].title}
                                                color="pink"
                                                isNarrow={false}/>

                                            : null
                                    }
                                    {
                                        job[2] ?
                                            <CommissionedIndexPagePhoto
                                                link = {job[2].path}
                                                mainImageUrl={job[2].mainImageUrl}
                                                hoverImageUrl={job[2].hoverImageUrl}
                                                caption={job[2].title}
                                                color="pink"
                                                isNarrow={false}/>

                                            : null
                                    }

                                </div>
                            )
                        })}

                </div>

        );
    }
}

ListOfCommissionedJobs.propTypes = {
    jobs: PropTypes.array
}
export default ListOfCommissionedJobs;


// WEBPACK FOOTER //
// ./src/components/ListOfCommissionedJobs.js